module.exports = __webpack_public_path__ + "static/media/Equity_iconlogo.027e1468.svg";